import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InquiryPopupService {
  showMessage = new Subject<boolean>();

  constructor() {}

  showPopup() {
    this.showMessage.next(true);
  }
  hidePopup() {
    this.showMessage.next(false);
  }
}
